import { useSetUser } from '@haaretz/s-atoms/user';
import useMiniregRegistrationMutation from '@haaretz/s-client-data-hooks/sso/useMiniregRegistration';
import useRegistrationMutation from '@haaretz/s-client-data-hooks/sso/useRegistration';
import handleSsoResponse from '@haaretz/s-sso-utils/handle-response';
export default function useRegistration({ restEntryType, onSuccess, onError }) {
    const updateUser = useSetUser();
    const miniregRegistration = useMiniregRegistrationMutation({
        onSuccess: async (data)=>{
            handleSsoResponse(data);
            updateUser('login');
            /* istanbul ignore else */ if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        },
        onError
    });
    const registration = useRegistrationMutation({
        onSuccess: async (data)=>{
            handleSsoResponse(data);
            updateUser('login');
            /* istanbul ignore else */ if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        },
        onError
    });
    return restEntryType === 'NEWSLETTER_MINI_REG' || restEntryType === 'ARTICLE_MINI_REG' ? miniregRegistration : registration;
}

//# sourceMappingURL=useRegistration.js.map